const MuiButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&.MuiButton-sizeMedium": {
        minHeight: "50px",
      },
      "&.MuiButton-sizeSmall": {
        minHeight: "34px",
        fontSize: "10px",
        minWidth: "72px",
      },
      borderRadius: "5px",
      textTransform: "none",
      letterSpacing: "0",

      "&.Mui-disabled:not(.MuiLoadingButton-loading)": {
        opacity: 0.5,
        color: `${theme.palette.common.white}`,
      },

      "&.MuiLoadingButton-loading": {
        ".MuiCircularProgress-circle": {
          color: theme.palette.common.white,
        },

        "*:not(.MuiLoadingButton-loadingIndicator) > ": {
          opacity: 0.3,
        },
      },
    }),
  },

  defaultProps: {
    variant: "contained",
    disableElevation: true,
  },
};

export default MuiButton;
